const ProfileIcon = ({ ...props }) => (
  <svg viewBox='0 0 24 24' {...props}>
    <path
      d='M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5zm-7 8a7 7 0 0 1 14 0'
      stroke='currentColor'
      strokeWidth='1.6'
      fill='none'
    />
  </svg>
);

export default ProfileIcon;
